/**
 * Copyright (C) IRT GmbH 2020
 *
 * @author Michael Probst
 */

var EventEmitter = require('events');

/**
 * Wrapper to handle local storage (and in future maybe also cookies for terminals not supporting local storage)
 */
module.exports = function () {

    /**
     * @type {import ('events').EventEmitter}
     */
    var emitter = new EventEmitter();

    var storage = localStorage;

    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
    function isAvailable () {
        try {
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return e instanceof DOMException && (
                // everything except Firefox
                e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                // acknowledge QuotaExceededError only if there's something already stored
                (storage && storage.length !== 0);
        }
    }

    /**
     * Sets a key/value pair in local storage. Both parameters are required to be non-empty strings.
     *
     * Emits an event with type equal to key and val as parameter.
     *
     * @param {string} key
     * @param {string} val
     * @returns true if setting value in storage succeeded, else false.
     */
    function set (key, val) {
        if (typeof key == "string" && typeof val == "string" && key.length > 0 && val.length > 0) {
            try {
                storage.setItem(key, val);
                emitter.emit(key, val);
                return true;
            } catch (e) {
            }
        }
        return false;
    }

    /**
     * Returns the stored value for key, or null.
     * @param {string} key
     */
    function get (key) {
        return storage.getItem(key);
    }

    /**
     * Removes a keys' value from storage.
     *
     * Emits an event with type equal to key and null as parameter.
     *
     * @param {string} key
     */
    function remove (key) {
        try {
            storage.removeItem(key);
            emitter.emit(key, null);
            return true;
        } catch (e) {
            return false;
        }
    }

    return {
        on  : emitter.on.bind(emitter),
        allOff : emitter.removeAllListeners.bind(emitter),
        once : emitter.once.bind(emitter),
        set : set,
        get : get,
        remove : remove,
        isAvailable : isAvailable
    };
}();
